<app-stepper [step]="step"></app-stepper>
<div>
	<div >
		<form #donationForm="ngForm" (ngSubmit)="onSubmit()" class="donation-form" >

			<p class="step2-story" [innerHTML]="'name.story' | translate:transParam"></p>

			<div class="form-group" >
				<mat-form-field class="width-100" >
					<input matInput type="text" id="firstname" class="form-control" name="firstname" [(ngModel)]="model.contact.firstName" placeholder="{{'name.firstname' | translate}}" required>
					<mat-error>{{'name.error.required' | translate}}</mat-error>
				</mat-form-field>
			</div>

			<div class="form-group" >
				<mat-form-field class="input-3cols" *ngIf="localeSupportsPrefix()">
					<input matInput type="text" id="prefix" class="form-control" name="prefix" [(ngModel)]="model.contact.prefix" placeholder="{{'name.prefix' | translate}}">
				</mat-form-field>

				<mat-form-field [ngClass]="localeSupportsPrefix() ? 'input-6cols' : 'width-100'">
					<input matInput type="text" id="surname" class="form-control" name="surname" [(ngModel)]="model.contact.surname" placeholder="{{'name.surname' | translate}}" required >
					<mat-error>{{'name.error.required' | translate}}</mat-error>
				</mat-form-field>
			</div>

			<div class="form-group" >
				<mat-form-field class="width-100">
					<input matInput type="email" id="email" class="form-control" name="email" [(ngModel)]="model.contact.emailAddress" placeholder="{{'name.email' | translate}}" required pattern="[^@]+@[^@]+\.[^\.]{2,63}$">
					<mat-error>{{'name.error.required' | translate}}</mat-error>
				</mat-form-field>
			</div>

			<div class="form-group">
				<button type="submit" btn btn-secondary btn-block btn-lg [disabled]="!donationForm.form.valid">{{'donation.next_step' | translate}}</button>
			</div>
			<a routerLink="/" routerLinkActive="active" class="link-back">{{'name.previous_step' | translate}}</a>
		</form>
	</div>

</div>
